var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { UrlHelper } from "../../../helper/UrlWrapper";
import { currMonthDefaultDate } from "../../../helper/defaultDate";
import { getDateAtZeroPoint } from '../../../helper/dateUtil';
import GoodService from "../../../api/GoodService";
import PurchaseReportForUpperSupService from '../../../api/PurchaseReportForUpperSupService';
function getInitFormData() {
    var initFormData = {
        order_from: 1,
        time_type: 1,
        supplier_upper_id: [],
        keyword_type: 1,
        goods_type_id: [],
        keyword: '',
        s_time: currMonthDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: currMonthDefaultDate().End.format('yyyy-MM-dd')
    };
    return initFormData;
}
var Header = (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, getInitFormData());
        _this.type = [
            {
                id: 1,
                label: "单号"
            },
            {
                id: 2,
                label: "货品"
            }
        ];
        _this.treeData = [];
        _this.exportDetail = {};
        _this.palceholderTxt = ['请输入关键字查询', '请输入单号'];
        _this.orderFromOptions = [
            { id: 1, label: '全部' },
            { id: 2, label: '采购入库' },
            { id: 3, label: '采购退货' },
        ];
        _this.orderTypeOptions = [
            { id: 1, label: '按货品查询' },
            { id: 2, label: '按采购订货单' },
            { id: 3, label: '按采购入库单' },
            { id: 4, label: '按采购退货单' }
        ];
        _this.dateTypeOptions = [
            { id: 1, label: '审核日期' },
            { id: 2, label: '制单日期' }
        ];
        _this.categoryData = [];
        _this.dateItems = [
            { id: 1, label: '本日' },
            { id: 2, label: '昨日' },
            { id: 3, label: '本周' },
            { id: 4, label: '上周' },
            { id: 5, label: '本月' },
            { id: 6, label: '上月' },
        ];
        _this.startPickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        _this.endPickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        return _this;
    }
    Header.prototype.watch_s_time = function (newValue, oldValue) {
        this.endPickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var start = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() < start.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    Header.prototype.watch_e_time = function (newValue, oldValue) {
        this.startPickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var end = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() > end.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    Header.prototype.created = function () {
        this.service = PurchaseReportForUpperSupService.getInstance();
        this.goodService = GoodService.getInstance();
    };
    Header.prototype.mounted = function () {
        this.getCategory();
        this.getTreeCategoryData();
    };
    Header.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
    };
    Header.prototype.getCategory = function () {
        var _this = this;
        this.goodService.getCategory({ level: 4 }).then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Header.prototype.getTreeCategoryData = function () {
        var _this = this;
        this.service.getSupplierupperCategoryList({
            has_supplier: 1
        }).then(function (res) {
            res.data.data.map(function (item) {
                if (item.category_id || item.category_name) {
                    item.supplier_upper_id = 'category_id' + item.category_id;
                    item.supplier_upper_name = item.category_name;
                }
                if (item.children && item.children.length > 0) {
                    item.children.map(function (child, index) {
                        child.parent_id = item.category_id;
                        child.parent_name = item.category_name;
                    });
                }
            });
            _this.treeData = res.data.data;
        });
    };
    Header.prototype.exportData = function () {
        var url = "supplierclientapi/purchase_report/export?";
        url = UrlHelper.addParam(url, 'order_from', this.formData.order_from);
        url = UrlHelper.addParam(url, 'time_type', this.formData.time_type);
        var supplier_upper_id = (this.formData.supplier_upper_id || []).filter(function (item) { return !((typeof item === 'string') && item.indexOf('category_id') > -1); });
        url = UrlHelper.addParam(url, 'supplier_upper_id', (supplier_upper_id || []).join(','));
        url = UrlHelper.addParam(url, 'keyword_type', this.formData.keyword_type);
        if (this.formData.keyword_type == '1') {
            url = UrlHelper.addParam(url, 'goods_type_id', (this.formData.goods_type_id || []).join(','));
        }
        url = UrlHelper.addParam(url, 'keyword', this.formData.keyword);
        url = UrlHelper.addParam(url, 'order_from', this.formData.order_from);
        url = UrlHelper.addParam(url, 's_time', _.isDate(this.formData.s_time) ? this.formData.s_time.format('yyyy-MM-dd') : this.formData.s_time);
        url = UrlHelper.addParam(url, 'e_time', _.isDate(this.formData.e_time) ? this.formData.e_time.format('yyyy-MM-dd') : this.formData.e_time);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        console.log(url);
        location.href = url;
    };
    Header.prototype.reset = function () {
        this.formData = __assign({}, getInitFormData());
    };
    Header.prototype.setDate = function (item) {
        var currentWeekDay = new Date().getDay();
        switch (item.id) {
            case 1:
                this.formData.s_time = new Date();
                this.formData.e_time = new Date();
                break;
            case 2:
                this.formData.s_time = new Date(Date.now() - 24 * 3600 * 1000);
                this.formData.e_time = new Date(Date.now() - 24 * 3600 * 1000);
                break;
            case 3:
                this.formData.s_time = new Date(Date.now() - (currentWeekDay - 1) * 24 * 3600 * 1000);
                this.formData.e_time = new Date();
                break;
            case 4:
                this.formData.s_time = new Date(Date.now() - (currentWeekDay - 1 + 7) * 24 * 3600 * 1000);
                this.formData.e_time = new Date(Date.now() - currentWeekDay * 24 * 3600 * 1000);
                break;
            case 5:
                var s_date = new Date();
                var e_date = new Date();
                var currentMonth = e_date.getMonth();
                var nextMonth = ++currentMonth;
                var nextMonthFirstDay = new Date(e_date.getFullYear(), nextMonth, 1).getTime();
                var oneDay = 1000 * 60 * 60 * 24;
                this.formData.s_time = new Date(s_date.setDate(1));
                this.formData.e_time = new Date();
                break;
            case 6:
                var nowdays = new Date();
                var year = nowdays.getFullYear();
                var month = nowdays.getMonth();
                if (month == 0) {
                    month = 12;
                    year = year - 1;
                }
                if (month < 10) {
                    month = '0' + month;
                }
                var nowDate = new Date(year, month, 0);
                var snowDate = new Date(year, month, 0);
                var s_date_r = snowDate.setDate(1);
                this.formData.s_time = new Date(s_date_r);
                this.formData.e_time = new Date(nowDate.getTime());
                break;
        }
    };
    Header.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    Header.prototype.normalizerSupplier = function (node) {
        return {
            id: node.supplier_upper_id,
            label: node.supplier_upper_name,
            children: node.children,
        };
    };
    __decorate([
        Prop({
            type: Number
        })
    ], Header.prototype, "total", void 0);
    __decorate([
        Watch("formData.s_time", { immediate: true })
    ], Header.prototype, "watch_s_time", null);
    __decorate([
        Watch("formData.e_time", { immediate: true })
    ], Header.prototype, "watch_e_time", null);
    Header = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], Header);
    return Header;
}(Vue));
export default Header;
